import VarietySearchSelect from './VarietySearchSelect';

export default VarietySearchSelect;
